import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Observable, of } from 'rxjs';
import { Action } from '@ngrx/store';

import * as PublicWifiPxsplusActions from './../actions/public-wifi-pxsplus.actions';
import { IEntity } from '@proximus/entity-manager';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { TechnicalError } from '@dch/products-business-logic';
import { PublicWifiPxsplusService } from '../../services/public-wifi-pxsplus.service';

@Injectable()
export class PublicWifiPxsplusEffects {
  @Effect()
  products$: Observable<Action> = this.actions$.pipe(
    ofType(PublicWifiPxsplusActions.GET_PUBLIC_WIFI_PXSPLUS_PRODUCTS),
    mergeMap((action: PublicWifiPxsplusActions.GetPublicWifiPxsplusProducts) =>
      this.publicWifiPxsplusService.getProducts().pipe(
        map(
          (entity: any) =>
            new PublicWifiPxsplusActions.GetPublicWifiPxsplusProductsSuccess(
              entity,
            ),
        ),
        catchError((error: IEntity<TechnicalError>) => {
          if (error.status === 304) {
            return of(
              new PublicWifiPxsplusActions.GetPublicWifiPxsplusProductsSuccess(
                (error as any).headers,
              ),
            );
          }
          return of(
            new PublicWifiPxsplusActions.GetPublicWifiPxsplusProductsFailed(
              error.errorData as TechnicalError,
            ),
          );
        }),
      ),
    ),
  );

  @Effect()
  configureUrl$: Observable<Action> = this.actions$.pipe(
    ofType(PublicWifiPxsplusActions.GET_PUBLIC_WIFI_PXSPLUS_CONFIGURE_URL),
    mergeMap(
      (action: PublicWifiPxsplusActions.GetPublicWifiPxsplusConfigureURL) =>
        this.publicWifiPxsplusService.getConfigureURL(action.payload).pipe(
          map(
            (entity: any) =>
              new PublicWifiPxsplusActions.GetPublicWifiPxsplusConfigureURLSuccess(
                entity.value,
              ),
          ),
          catchError((error: IEntity<TechnicalError>) =>
            of(
              new PublicWifiPxsplusActions.GetPublicWifiPxsplusConfigureURLFailed(
                error.errorData as TechnicalError,
              ),
            ),
          ),
        ),
    ),
  );

  constructor(
    private actions$: Actions,
    private publicWifiPxsplusService: PublicWifiPxsplusService,
  ) {}
}
